import { css } from "@emotion/react";
import { rem } from "polished";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";

import { migrateModalSeenAtom } from "../atoms";
import {
  A,
  Box,
  Button,
  Buttons,
  Flex,
  P,
  SecondaryButton,
  Semi,
  Spacer,
} from "../base";
import Strings from "../lib/strings";
import { useSuppressMigrateModal } from "../modules/hooks";
import { FXCToAmp } from "./Icons";
import MiniCheckbox from "./MiniCheckbox";
import Modal from "./Modal";

const MigrateModal = () => {
  const [suppressMigrateModal, setSuppressMigrateModal] =
    useSuppressMigrateModal();
  const setMigrateModalSeen = useSetRecoilState(migrateModalSeenAtom);
  const history = useHistory();
  const [checked, setChecked] = useState(suppressMigrateModal);

  const onClickNow = () => {
    setMigrateModalSeen(true);
    if (checked) {
      setSuppressMigrateModal(true);
    }
  };

  const onClickLater = () => {
    setMigrateModalSeen(true);
    history.push("/");
    if (checked) {
      setSuppressMigrateModal(true);
    }
  };

  return (
    <Modal
      boxCss={css`
        width: ${rem(720)};
      `}
      icon={FXCToAmp}
      iconProps={css`
        width: ${rem(185)};
      `}
      innerCss={css`
        padding: 4rem;
      `}
      title={`Migrate your Flexacoin to Amp before ${Strings.fxcEndSupportDate}`}
    >
      <Flex column>
        <Spacer size={36} />
        <Box>
          <P color="#555555">
            <Semi>
              As part of Flexa’s{" "}
              <A href={Strings.announceBlogLink} target="_blank">
                transition to Amp
              </A>
              , Capacity will stop supporting FXC as collateral on{" "}
              {Strings.fxcEndSupportDate}.
            </Semi>
          </P>
          <P color="#555555">
            If you do not migrate to Amp before that time, your FXC can still be
            withdrawn from Capacity, but you will no longer earn any network
            rewards. (Any rewards that you have previously earned have already
            been migrated to Amp for you.)
          </P>
        </Box>

        <Spacer size={60} />
        <Buttons>
          <SecondaryButton
            as={Link}
            title="Migrate now"
            to="/migrate"
            onClick={onClickNow}
          ></SecondaryButton>
          <Button title="I’ll migrate later" onClick={onClickLater}></Button>
        </Buttons>

        <Spacer size={48} />

        <MiniCheckbox
          checked={checked}
          label="Don’t show this message again"
          onCheck={setChecked}
        />
      </Flex>
    </Modal>
  );
};

export default MigrateModal;
